import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DrawerService {

  public opened: WritableSignal<boolean> = signal(false);

  constructor() { }

  open() {
    this.opened.set(true);
  }

  close() {
    this.opened.set(false);
  }
}
